var map = {
	"./layout-admin": 7567,
	"./layout-admin.vue": 7567,
	"./layout-default": 7960,
	"./layout-default.vue": 7960,
	"./layout-exterior": 5745,
	"./layout-exterior.vue": 5745,
	"./layout-hostadmin": 8893,
	"./layout-hostadmin.vue": 8893
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1012;